<template>
  <aside class="page-sidebar">
    <div class="page-logo bg-dark">
      <a
        class="page-logo-link press-scale-down pb-1 align-items-center position-relative"
        href="https://edu.lublin.eu"
        target="_blank"
        aria-label="Otwarcie w nowej karcie: strona edu.lublin.eu"
      >
        <img src="/img/logo_edu_lublin.svg" aria-roledescription="logo" alt="Logo Edu Lublin" />
      </a>
    </div>

    <nav id="js-primary-nav" class="primary-nav " role="navigation">
      <ul class="nav-menu mt-0">
        <check-permission
          v-for="item in menuItems"
          :key="item.title"
          :permissions="item.permissions"
          :entity-id="getEntityId(item)"
          :entity-type="item.entityType"
          :join-type="item.permissionJoin"
        >
          <nav-item :item="item" />
        </check-permission>
      </ul>
    </nav>
  </aside>
</template>
<script>
import { mapState } from 'vuex';

import { buildMenu, getMenuElements } from '@/utils/menu';
import { getProfileId } from '@/utils/profile';
import NavItem from './NavItem.vue';

// @vuese
// Menu boczne
// @group AppLayout
export default {
  name: 'Navbar',
  components: { NavItem },
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle,
      menuItems: state => [
        {
          title: state.auth.data ? `${state.auth.data.firstName} ${state.auth.data.lastName}` : 'Profil',
          icon: 'fa-user',
          permissions: ['USER.GET'],
          entityType: 'profile',
          entityId: getProfileId(),
          name: 'myProfile'
        },
        ...state.menu.menu
      ],
      fullName: state => state.auth.data && `${state.auth.data.firstName} ${state.auth.data.lastName}`
    })
  },
  methods: {
    getEntityId(menuItem) {
      if (menuItem.entityId && typeof menuItem.entityId === 'function') {
        return menuItem.entityId();
      }
      return menuItem.entityId;
    }
  }
};
</script>

<style>
.nav-menu li a > [class*='fa-'],
.nav-menu li a > .ni {
  color: #6fbe41;
  font-size: 1.2rem;
}
.nav-menu li a:hover > [class*='fa-'],
.nav-menu li a:hover > .ni,
.nav-menu li a:focus > [class*='fa-'],
.nav-menu li a:focus > .ni {
  color: #ffffff !important;
}
.nav-menu li a:hover,
.nav-menu li a:focus {
  color: white;
  background-color: #6fbe41;
}
.smart-version {
  position: absolute;
  top: -15px;
  right: 0;
  font-size: 75%;
  color: black;
  opacity: 0.6;
}

.profile-image {
  width: 60% !important;
}

.info-card-text {
  margin-left: 0 !important;
}

.pull-trigger-btn {
  margin-right: 0 !important;
}

.page-sidebar .page-logo-link img {
  max-height: 4.125rem;
}
</style>
